import { useViewport } from 'contexts/viewport';
import { Container, Stack, Text, styled } from 'shell/components';

const LTIIncomplete = () => {
    const { device } = useViewport();

    return (
        <Container device={device}>
            <Stack alignItems={'center'} spacing={4}>
                <Text color={'light'} variant={'h6'} weight={'semibold'}>
                    You do not have permission to access this platform.
                </Text>
                <Text color={'light'} variant={'h6'} weight={'semibold'}>
                    Please contact IT service for the assistance.
                </Text>
            </Stack>
            <CustomText>{process.env.REACT_APP_GIT_TAG}</CustomText>
        </Container>
    );
};

const CustomText = styled(Text)(({ theme }) => {
    return {
        position: 'absolute',
        bottom: theme.spacing(1),
        right: theme.spacing(1),
    };
});

export default LTIIncomplete;
